import { GetShopProductsPriceAndInventoryQuery } from './getShopProductsPriceAndInventory';

type GetShopProductsPriceAndInventoryQueryWrapper = {
  data: GetShopProductsPriceAndInventoryQuery;
  extensions: {
    cost: {
      'shop-product-catalog': {
        maxQueryCost: number;
        requestedQueryCost: number;
        actualQueryCost: number;
      };
      'item-price-service': {
        maxQueryCost: number;
        requestedQueryCost: number;
        actualQueryCost: number;
      };
      'graphql-api': {
        maxQueryCost: number;
        requestedQueryCost: number;
        actualQueryCost: number;
      };
    };
  };
};

export default {
  data: {
    shopProductBySkuId: {
      id: '556',
      variantBySkuId: {
        sku: '2413822',
        price: {
          currency: 'USD',
          value: 9800,
        },
        inventory: {
          availability: 'OUT_OF_STOCK',
        },
      },
      colorOptions: [
        {
          name: 'Grey',
          position: 166,
          uniqueColorId: '281745',
          swatch: {
            hex: '#837f7c',
            url: null,
          },
          inventory: {
            availability: 'LIMITED_STOCK',
          },
        },
      ],
    },
  },
  extensions: {
    cost: {
      'shop-product-catalog': {
        maxQueryCost: 5000,
        requestedQueryCost: 360,
        actualQueryCost: 258,
      },
      'item-price-service': {
        maxQueryCost: 5000,
        requestedQueryCost: 4,
        actualQueryCost: 150,
      },
      'graphql-api': {
        maxQueryCost: 5000,
        requestedQueryCost: 2,
        actualQueryCost: 2,
      },
    },
  },
} as GetShopProductsPriceAndInventoryQueryWrapper;
